import { useState, useEffect } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router'
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import { getBellPrompt, updateBellPrompt } from '../../../services/websitesService';


const BellPrompt = () => {

    const history = useHistory();
    
    
    const {selectedWebsite,
        setMenuCollapsed,
        setPathToNavigate,
        setDiscardPromptOpen, 
        isDirty, 
        setIsDirty,
    }= useAppContext();

    const [ bellPromptData, setBellPromptData ] = useState(null);

    const [ subscriberType, setSubscriberType ] = useState('');
    const [ subscriptionValue, setSubscriptionValue ] = useState(null);
    

    const [ openAcc,setOpenAcc ] = useState('design');


    const [ background, setBackground ] = useState('#FFFFFF');
    const [ bellPosition, setBellPosition] = useState('left');


    useEffect(() => {
        const discard = () => {
            setDefaultSelected(bellPromptData);
        }
        document.addEventListener('discardEvent', discard);
        setMenuCollapsed(true);
        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [bellPromptData])


    useQuery(['fetchGDPRPrompt', selectedWebsite?.id],  () => getBellPrompt(selectedWebsite?.id) , {
        enabled: !!selectedWebsite,
        onSuccess: (gdprPromptData) => {
            setBellPromptData(gdprPromptData);
            setDefaultSelected(gdprPromptData);
        }
    });

    
    const setDefaultSelected = (promptData) => {

        setBackground(promptData?.background || '');
        setBellPosition(promptData?.position)

        setSubscriberType(promptData?.start_mode || 'OPL');
        if(promptData?.start_mode !== 'OPL') {
            setSubscriptionValue(promptData?.start_mode_value);
        }
    }


    const getPromptData = () => {
        const formData = new FormData();
        formData.append('background', background);
        formData.append('start_mode', subscriberType);
        formData.append('position', bellPosition);
        if(subscriberType !== 'OPL') {
            formData.append('start_mode_value', subscriptionValue);
        }
    
        return formData;
    
    }

    const discard = () => {
        setDiscardPromptOpen(true);
    }

    const onSave = (event) => {
        event.preventDefault();
        const promptData = getPromptData();
        savePrompt.mutate(promptData);

    }

    const savePrompt = useMutation((formData) => {
        return updateBellPrompt(selectedWebsite?.id, formData);
    }, {
        onSuccess: (bellPromptData) => {
            if(bellPromptData?.errors) {

            } else {
                setDefaultSelected(bellPromptData);
                setIsDirty(false);
                toast.success('Bell Permission Prompt updated successfully');
            }
        }
    });

    const handelAccordion = (accordion) => {
        if(openAcc === accordion) {
            setOpenAcc(null);
        } else {
            setOpenAcc(accordion);
        }
    }

    const isSaveDisabled = () => {
        return subscriberType !== 'OPL' && (!subscriptionValue  ||  (subscriptionValue && subscriptionValue.length <= 0))
    }

    const goBack = () => {
        if(isDirty) {
            setPathToNavigate('/permission-prompt')
            setDiscardPromptOpen(true);
        } else {
            history.push('/permission-prompt');
        }
    }

    const handelBellPosition = (position) => {
        setBellPosition(position);
        setIsDirty(true);
    }

    const handelBgColor = (value) => {
        setBackground(value);
        setIsDirty(true);
    }

    return <> 
        <div className="panel d-flex-flex-column full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-space-between">
                    <div>
                        <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={goBack} ></i>Bell</h3>
                    </div>
                    <div className="d-flex justify-content-between" style={{gap: '10px'}}>
                        <button className="btn btn-sm btn-danger" disabled={!isDirty} onClick={discard} >Discard</button>
                        <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={onSave}>Save</button>                                         
                    </div> 
                </div>              
                                
            </div>
            <div className="panel-body p-0 d-flex flex-column full-height scrollable_y">
                <div className="row no-gutters full-height">
                    <div className="col-12 col-xl-4 d-flex flex-column br-right">
                        <div className="my-2 mx-4">
                            <div className="panel panel-bordered">
                                <div className="panel-header m-0 p-2" onClick={() => handelAccordion('C&A')}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0 medium">Content &amp; Appearance</h6>
                                        <button className="btn btn-neutral"><i 
                                        className={ openAcc === 'C&A'? 'increment-icon increment-icon-sm default' : 'decrement-icon decrement-icon-sm default'}
                                        ></i></button>
                                    </div>  
                                </div>
                                <div className="panel-body p-2" style={{display: openAcc === 'C&A' ? 'block' : 'none'}}>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                    <label>Bell position</label>
                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        <button 
                                            type="button" 
                                            className= {bellPosition === 'left' ? 'btn btn-primary': 'btn btn-outline' }
                                            onClick={() => handelBellPosition('left')}    
                                        ><i className="icon "></i>Left</button>
                                        <button 
                                            type="button" 
                                            className= {bellPosition === 'right' ? 'btn btn-primary': 'btn btn-outline' }
                                            onClick={() => handelBellPosition('right')}
                                        ><i className="icon "></i>Right</button>
                                    </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                    <label>Background Color</label>
                                    <div>
                                        <input 
                                            type="color" 
                                            value={background}
                                            onChange={({target}) => handelBgColor(target.value)}    
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className="col-12 col-xl-8 d-sm-none d-md-block full-height">
                        <div className="d-flex flex-column p-4 full-height">
                            <h5 className="px-3 mb-0">Preview</h5>
                            <div className="panel panel-bordered full-height m-2">
                                <div className="panel-header m-0 bg-light-grey">
                                    <div className="indicators d-flex">
                                        <div className="red"></div>
                                        <div className="grey"></div>
                                        <div className="green"></div>
                                    </div>
                                </div>
                                <div className="panel-body p-0 full-height">
                                    <div className="preview-container bg-grey full-height">
                                        <div 
                                            className="prompt-alert"
                                            data-alert="notification" 
                                            style={{
                                                right: bellPosition ==='right' ? '1rem' : 0,
                                                left: bellPosition === 'left' ? '1rem': null,
                                                backgroundColor: background
                                            }} 
                                        >
                                            <div className="prompt-notification">
                                                <i className="icon icon-2x icon-notification"></i>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>                                    
                    </div>
                </div>
            </div>
        </div>
    </>
}


export default BellPrompt